import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../../assets/images/YOGA KAREGA INDIA (7).png";
import './AdminSideNav.css';

const AdminSideNav = ({ activeTab, setActiveTab, counts }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear user data from localStorage
    localStorage.removeItem('userData');
    localStorage.removeItem('currentUserData');

    // Dispatch auth change event
    window.dispatchEvent(new Event('authChanged'));

    // Redirect to login page
    navigate('/login');
  };

  const menuItems = [
    {
      id: 'trainers',
      label: 'Yoga Trainers',
      icon: '🧘‍♂️',
      count: counts?.trainers || 0
    },
    {
      id: 'partner_apps',
      label: 'Partner Registrations',
      icon: '🤝',
      count: counts?.partnerApplications || 0
    },
    {
      id: 'community_chat',
      label: 'Community Chat',
      icon: '💬',
      count: 0
    }
  ];

  return (
    <nav className="admin-side-nav">
      <div className="admin-nav-header">
        <img src={logo} alt="Yoga Karega India" className="admin-logo" onClick={() => navigate('/')} />
        <h3>Admin Panel</h3>
      </div>

      {/* Scrollable Menu Container */}
      <div className="admin-nav-menu-container">
        <ul className="admin-nav-menu">
          {menuItems.map((item) => (
            <li key={item.id} className={`admin-nav-item admin-nav-item-${item.id}`}>
              <button
                className={`admin-nav-btn ${activeTab === item.id ? 'active' : ''}`}
                onClick={() => setActiveTab(item.id)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
                {item.count > 0 && (
                  <span className="nav-count">{item.count}</span>
                )}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Fixed Logout Footer */}
      <div className="admin-nav-footer desktop-only">
        <button className="admin-logout-btn" onClick={handleLogout}>
          <span className="nav-icon">🚪</span>
          <span className="nav-label">Logout</span>
        </button>
      </div>
    </nav>
  );
};

export default AdminSideNav;
